import { Link } from 'react-router-dom';
import ProductCard from '../product/ProductCard';
import { campaignHref } from '../../utils/campaign';
import './CampaignSection.css';

/**
 * A campaign rendered inline on the home page as a titled product section,
 * with a link through to the full curated list.
 */
const CampaignSection = ({ campaign }) => {
  const products = campaign?.products || [];
  if (!campaign || products.length === 0) return null;

  return (
    <section className="campaign-section">
      <div className="campaign-section-header" data-reveal-item>
        <div className="campaign-section-heading">
          {campaign.kicker && (
            <span className="campaign-section-kicker">{campaign.kicker}</span>
          )}
          <h2 className="campaign-section-title">{campaign.title}</h2>
          {campaign.subtitle && (
            <p className="campaign-section-subtitle">{campaign.subtitle}</p>
          )}
        </div>
        <Link to={campaignHref(campaign)} className="campaign-section-link">
          View all
        </Link>
      </div>

      <div className="campaign-section-grid">
        {products.map((product, index) => (
          <div
            key={product.id}
            data-reveal-item
            style={{ '--reveal-index': index + 1 }}
          >
            <ProductCard product={product} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default CampaignSection;
